<div class="dropdown filter-card filter-dropdown">
    <button class="filter-card-btn" type="button" data-toggle="dropdown" data-display="static"
        aria-haspopup="true" aria-expanded="false">
        <i class="fa {{icon}} filter-card-icon"></i>
        <span class="filter-card-text">
            <span class="filter-card-label">{{label}}</span>
            <span class="filter-card-value">{{selectedLabel ? selectedLabel : (isChip ? label : allLabel)}}</span>
        </span>
        <span class="fa fa-chevron-down filter-card-caret"></span>
    </button>
    <div class="dropdown-menu">
        <input *ngIf="searchable" type="text" class="dropdown-search" [placeholder]="searchPlaceholder"
            [ngModel]="searchText" (ngModelChange)="onSearchTextChange($event)" (click)="$event.stopPropagation()">

        <span class="dropdown-itemm pointer" (click)="select(null)">{{allLabel}}</span>

        <ng-container *ngIf="!groupedOptions">
            <ng-container *ngFor="let option of options">
                <span class="dropdown-itemm pointer" (click)="select(option)">{{displayFn(option)}}</span>
            </ng-container>
            <span class="dropdown-itemm dropdown-itemm--empty" *ngIf="searchable && searchText && !options?.length">No results found</span>
        </ng-container>

        <ng-container *ngIf="groupedOptions">
            <ng-container *ngIf="groupedOptions.networkTeams.length">
                <span class="dropdown-group-label" *ngIf="groupedOptions.networkLabel">{{groupedOptions.networkLabel}}</span>
                <ng-container *ngFor="let option of groupedOptions.networkTeams">
                    <span class="dropdown-itemm pointer" [class.dropdown-itemm--indented]="groupedOptions.networkLabel" (click)="select(option)">{{displayFn(option)}}</span>
                </ng-container>
            </ng-container>
            <ng-container *ngFor="let bucket of groupedOptions.groupedTeams">
                <span class="dropdown-group-label">{{bucket.groupName}}</span>
                <ng-container *ngFor="let option of bucket.teams">
                    <span class="dropdown-itemm pointer dropdown-itemm--indented" (click)="select(option)">{{displayFn(option)}}</span>
                </ng-container>
            </ng-container>
            <span class="dropdown-itemm dropdown-itemm--empty" *ngIf="searchable && searchText && !groupedOptions.networkTeams.length && !groupedOptions.groupedTeams.length">No results found</span>
        </ng-container>
    </div>
</div>
